/* =========================================================
   AUTOCLINIC MAIN CAR SELECTOR SCRIPT
   Direct variant-SKU collection view integration.
   Install with the accompanying collection templates and assets.
========================================================= */

/* =========================================================
   01. CONFIG / GLOBAL VARIABLES
========================================================= */

// Paste the Google Apps Script Web App /exec URL here after deployment.
var GOOGLE_DATA_URL = 'https://script.google.com/a/macros/autoclinic.com/s/AKfycbzOZK6tOX1eJjapK5gUP1Roy3dprzgYScQ0M4vwXRN-wxHc9b4bAJrOPvVEYKOTrOQ/exec';
var jsonDataUrl = GOOGLE_DATA_URL + '?dataset=carDb';
var jsonBrandDataUrl = GOOGLE_DATA_URL + '?dataset=filter';
const autoclinicRequests = {};
function loadAutoclinicData(dataset) {
  if (autoclinicRequests[dataset]) return autoclinicRequests[dataset];
  const deferred = $.Deferred();
  autoclinicRequests[dataset] = deferred.promise();
  const storageKey = 'autoclinic-google-data-v3-deployment4-' + dataset;
  function expandData(data) {
    if (dataset !== 'carDb' || !data || !Array.isArray(data.fields) || !Array.isArray(data.carDb)) return data;
    const emptyFields = Object.fromEntries(data.fields.map(key => [key, '']));
    return { ...data, carDb: data.carDb.map(row => ({ ...emptyFields, ...row })) };
  }
  function valid(data) {
    return data && !data.error && Array.isArray(data[dataset]) && data[dataset].length > 0;
  }
  function fail(error) {
    let saved;
    try { saved = JSON.parse(localStorage.getItem(storageKey)); } catch (_) {}
    // Keep the last good dataset for temporary outages, for at most 24 hours.
    if (saved && Date.now() - saved.savedAt < 86400000 && valid(saved.data)) {
      console.warn('Using saved vehicle data because the data service is unavailable.');
      deferred.resolve(expandData(saved.data));
    } else {
      delete autoclinicRequests[dataset];
      console.error('Vehicle data could not be loaded:', dataset, error);
      deferred.reject(error);
      $('.jsc-loader-overlay').hide();
      $('.autoclinic-data-status').text('Vehicle data unavailable. Please reload to try again.');
      document.dispatchEvent(new CustomEvent('autoclinic:data-error', { detail: { dataset } }));
    }
  }
  if (!/^https:\/\/script\.google\.com\/(?:a\/macros\/[a-zA-Z0-9.-]+\/s|macros\/s)\/[^/]+\/exec$/.test(GOOGLE_DATA_URL)) {
    fail(new Error('Configure GOOGLE_DATA_URL with the deployed /exec URL.'));
    return deferred.promise();
  }
  // Reuse the last good dataset immediately for repeat visits (up to 24 hours).
  // After five minutes, refresh storage for the next page without interrupting
  // the current selection or rebuilding live dropdowns under the customer.
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey));
    const age = saved ? Date.now() - saved.savedAt : Infinity;
    if (saved && age >= 0 && age < 86400000 && valid(saved.data)) {
      deferred.resolve(expandData(saved.data));
      if (age >= 300000) {
        $.ajax({
          url: GOOGLE_DATA_URL,
          data: { dataset, compact: 1 },
          dataType: 'jsonp', jsonp: 'callback', timeout: 45000
        }).done(function (fresh) {
          if (!valid(fresh)) return;
          try { localStorage.setItem(storageKey, JSON.stringify({ savedAt: Date.now(), data: fresh })); } catch (_) {}
        });
      }
      return deferred.promise();
    }
  } catch (_) {}

  $.ajax({
    url: GOOGLE_DATA_URL,
    data: { dataset, compact: 1 },
    dataType: 'jsonp',
    jsonp: 'callback',
    timeout: 45000
  }).done(function (data) {
    const cacheData = data;
    data = expandData(data);
    if (!valid(data)) { fail(new Error('Invalid or empty data response.')); return; }
    try { localStorage.setItem(storageKey, JSON.stringify({ savedAt: Date.now(), data: cacheData })); } catch (_) {}
    deferred.resolve(data);
  }).fail(function (_, status, error) { fail(error || status); });
  return deferred.promise();
}


// Preserve the active Malaysia or Singapore storefront in vehicle links.
function autoclinicMarketPrefix() {
  const match = window.location.pathname.match(/^\/(en-(?:my|sg))(?=\/|$)/i);
  return match ? '/' + match[1].toLowerCase() : '';
}

// Market-specific vehicle make visibility. Existing /en-my and /en-sg routes
// take priority; unprefixed routes use Shopify's country, defaulting to PH.
function autoclinicIsPHMarket() {
  const path = window.location.pathname;
  if (/^\/(?:[a-z]{2}-)?(?:my|sg)(?:\/|$)/i.test(path)) return false;
  if (/^\/(?:[a-z]{2}-)?ph(?:\/|$)/i.test(path)) return true;
  const country = String(window.Shopify?.country || '').trim().toUpperCase();
  return country ? country === 'PH' : true;
}
function autoclinicHiddenMake(make) {
  return autoclinicIsPHMarket() && /^(proton|perodua)$/i.test(String(make || '').trim());
}
function autoclinicClearHiddenMakeSelection() {
  if (!autoclinicIsPHMarket()) return;
  let confirmed = null;
  try { confirmed = JSON.parse(localStorage.getItem('autoclinicConfirmedVehicle')); } catch (_) {}
  const hiddenDraft = autoclinicHiddenMake(getLocalStorage('brand'));
  const hiddenConfirmed = autoclinicHiddenMake(confirmed?.brand);
  if (hiddenConfirmed) localStorage.removeItem('autoclinicConfirmedVehicle');
  if (hiddenDraft) {
    clearSelection();
    localStorage.removeItem('previousCarId');
    const url = new URL(window.location.href);
    url.searchParams.delete('carId');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }
}
function autoclinicRemoveHiddenMakeOptions() {
  if (!autoclinicIsPHMarket()) return;
  document.querySelectorAll('.jsc-brand .custom-select__listbox .custom-select__option').forEach(option => {
    if (autoclinicHiddenMake(option.getAttribute('data-value') || option.textContent)) option.remove();
  });
  document.querySelectorAll('.jsc-brand custom-select, custom-select.jsc-brand').forEach(control => {
    control.options = control.querySelectorAll('.custom-select__option');
    if (control.selectedOption && !control.contains(control.selectedOption)) control.selectedOption = null;
    if (control.focusedOption && !control.contains(control.focusedOption)) control.focusedOption = null;
  });
}
$(function () {
  if (!autoclinicIsPHMarket()) return;
  autoclinicRemoveHiddenMakeOptions();
  const observer = new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length && (
      record.target.closest?.('.jsc-brand') || [...record.addedNodes].some(node =>
        node.nodeType === 1 && (node.matches?.('.jsc-brand') || node.querySelector?.('.jsc-brand')))
    ))) autoclinicRemoveHiddenMakeOptions();
  });
  observer.observe(document.body, { childList:true, subtree:true });
});

// Custom collection view reads live variant.sku values; no metafield filter.
const SKU_FILTER_PARAM = 'sku';

function splitSkuValues(value) {
  if (Array.isArray(value)) return value.flatMap(splitSkuValues);
  if (typeof value !== 'string' && typeof value !== 'number') return [];
  return String(value).split('|').map(sku => sku.trim()).filter(Boolean);
}

function uniqueSkus(values) {
  return [...new Set(splitSkuValues(values))];
}

function carMatchesSku(car, sku) {
  const value = String(sku ?? '').trim();
  return value !== '' && carDbColumn.some(column => splitSkuValues(car[column]).includes(value));
}

function getSelectedVehicleRecord() {
  if (!Array.isArray(cachedCarDb)) return null;
  const brand = getLocalStorage('brand');
  const model = getLocalStorage('model');
  const engine = getLocalStorage('engine').split('--');
  if (!brand || !model || engine.length !== 4) return null;
  const value = input => String(input == null ? '' : input).trim().toLowerCase();
  const matches = cachedCarDb.filter(car =>
    value(car.make) === value(brand) && value(car.model) === value(model) &&
    [car.carName, car['power(kW)'], car.cyl, car.drivetype].every((item, index) => value(item) === value(engine[index]))
  );
  const prior = getLocalStorage('previousCarId');
  return matches.find(car => String(car.carId) === prior) || matches.find(car => car.carId) || null;
}
function syncSelectedCarId() {
  const selected = getSelectedVehicleRecord();
  if (!selected) return;
  const carId = String(selected.carId);
  localStorage.setItem('previousCarId', carId);
  const url = new URL(window.location.href);
  if (url.searchParams.get('carId') !== carId) {
    url.searchParams.set('carId', carId);
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }
  window.dispatchEvent(new Event('autoclinic:vehicle-id-updated'));
}

function buildSkuCollectionUrl(baseUrl, skus) {
  if (!uniqueSkus(skus).length) return null;
  const url = new URL(baseUrl, window.location.origin);
  url.searchParams.delete('filter.p.m.json.handle');
  url.searchParams.delete('filter.p.m.custom.skus');
  url.searchParams.delete('view');
  url.searchParams.delete('sku_page');
  url.searchParams.delete(SKU_FILTER_PARAM);
  url.searchParams.delete('page');
  uniqueSkus(skus).forEach(sku => url.searchParams.append(SKU_FILTER_PARAM, sku));
  const selected = getSelectedVehicleRecord();
  if (selected) url.searchParams.set('carId', String(selected.carId));
  return url.pathname + url.search + url.hash;
}

let cachedCarDb = null;
let indexedCarDb = null;
let indexedById = {};

// === Normalize helper ===
const normalize = (val) => String(val || '').trim().toLowerCase();

// === Indexing function ===


/* =========================================================
   02. DATABASE FETCHING / INDEXING
========================================================= */

function indexCarDb(carDb) {
    const index = {};

    carDb.forEach(car => {
        const make = normalize(car.make);
        const model = normalize(car.model);
        const carName = normalize(car.carName);
        const power = normalize(car['power(kW)']);
        const cyl = normalize(car.cyl);
        const drivetype = normalize(car.drivetype);
        const carId = car.carId;

        const key = `${carName}--${power}--${cyl}--${drivetype}`;

        if (!index[make]) index[make] = {};
        if (!index[make][model]) index[make][model] = {};
        if (!index[make][model][key]) index[make][model][key] = [];

        index[make][model][key].push(car);

        if (carId) {
            indexedById[carId] = car;
        }
    });

    return index;
}

let brandDb = null;
let exhaustDb = null; 

const fetchBrandrDb = () => {
   return loadAutoclinicData('filter').then((jsonData) => {
      brandDb = jsonData.filter;
      return brandDb;
   });
}; 

/* Start Automatic Car Selection Script */
const fetchCarDb = () => {
    return loadAutoclinicData('carDb')
        .then((jsonData) => {
            cachedCarDb = jsonData.carDb;
            prepareDropdownIndex(cachedCarDb);
            return cachedCarDb;
        });
};

// Function to check if `carId` has changed and clear selection if needed
// For page reload


/* =========================================================
   03. URL carId AUTO-SELECTION
========================================================= */

function checkCarIdChange() {
  const currentCarId = getCarIdFromURL();
  const previousCarId = localStorage.getItem("previousCarId");

  if (!currentCarId || currentCarId === previousCarId) return;

  const selectedCar = indexedById[currentCarId];
  if (!selectedCar || autoclinicHiddenMake(selectedCar.make)) return;

  const engineValue = `${selectedCar.carName}--${selectedCar['power(kW)']}--${selectedCar.cyl}--${selectedCar.drivetype}`;

  setLocalStorage('brand', selectedCar.make);
  setLocalStorage('model', selectedCar.model);
  setLocalStorage('engine', engineValue);
  localStorage.setItem("previousCarId", currentCarId);

  saveCarDetails(engineValue);
}

// Function to check if `carId` is in URL and `.jsc-my-model-detail` is empty
function reloadIfModelDetailIsEmpty() {
  return false;
}

// Run only after the car database is loaded


// Function to get carId from the URL
function getCarIdFromURL() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('carId'); // Extract ?carId=123 from URL
}

// Auto-Select Car from Database Based on carId in URL
function autoSelectCarFromURL() {
  var carId = getCarIdFromURL();
  if (!carId) return;

  var selectedCar = indexedById[carId];
  if (!selectedCar || autoclinicHiddenMake(selectedCar.make)) return;

  var engineValue = `${selectedCar.carName}--${selectedCar['power(kW)']}--${selectedCar.cyl}--${selectedCar.drivetype}`;

  setLocalStorage('brand', selectedCar.make);
  setLocalStorage('model', selectedCar.model);
  setLocalStorage('engine', engineValue);
  localStorage.setItem("previousCarId", carId);

  saveCarDetails(engineValue);
  updateFitmentDisplay(selectedCar);

  refreshSelectedCarUIFromStorage();
}

// Function to update the Fitment Display
function updateFitmentDisplay(selectedCar) {
    var fitmentBox = $(".fitment-confirmation-box");
    if (fitmentBox.length) {
        fitmentBox.html(`
            <span class="fitment-text">
                Fitment confirmed for <strong>${selectedCar.make} ${selectedCar.model}</strong> 
                ${selectedCar.carName} - ${selectedCar['power(kW)']}kW
            </span>
        `);
        fitmentBox.show();
    }
}

// Helper Function to Convert Text into Shopify-Compatible Format


/* =========================================================
   04. LOCAL STORAGE / BASIC HELPERS
========================================================= */

function handleizedString(string) {
    return string.replace(/\s+/g, '-')
        .replace(/\//g, '-')
        .trim()
        .toLowerCase()
        .replace(/\(|\)/g, '-')
        .replace(/--/g, '-')
        .replace('.', '-');
}

// Function to Save Values in Local Storage
function setLocalStorage(key, value) {
    localStorage.setItem(key, value);
}

// Function to Get Values from Local Storage
function getLocalStorage(key) {
    return localStorage.getItem(key) || "";
}



// Keep the confirmed vehicle separate from the dropdowns' in-progress values.
// Make/Model changes intentionally clear the existing model/engine keys.
function readConfirmedPopupVehicle() {
  try {
    const car = JSON.parse(getLocalStorage('autoclinicConfirmedVehicle'));
    if (car && ['brand', 'model', 'engine'].every(key =>
      typeof car[key] === 'string' && car[key].trim()
    )) return car;
  } catch (error) {
    // Ignore an invalid snapshot and migrate the existing selection below.
  }
  return null;
}

function getCompletePopupVehicle(engineValue) {
  const brand = getLocalStorage('brand');
  const model = getLocalStorage('model');
  const engine = engineValue || getLocalStorage('engine');
  if (!brand || !model || !engine || !cachedCarDb) return null;

  const parts = engine.split('--');
  if (parts.length !== 4) return null;
  const car = cachedCarDb.find(item =>
    normalize(item.make) === normalize(brand) &&
    normalize(item.model) === normalize(model) &&
    normalize(item.carName) === normalize(parts[0]) &&
    normalize(item['power(kW)']) === normalize(parts[1]) &&
    normalize(item.cyl) === normalize(parts[2]) &&
    normalize(item.drivetype) === normalize(parts[3])
  );
  return car ? { brand, model, engine } : null;
}

function seedConfirmedPopupVehicle() {
  // Migrate an existing full selection once; never replace it with a draft.
  if (readConfirmedPopupVehicle()) return;
  const car = getCompletePopupVehicle();
  if (car) setLocalStorage('autoclinicConfirmedVehicle', JSON.stringify(car));
}

function confirmPopupVehicle(engineValue) {
  const car = getCompletePopupVehicle(engineValue);
  if (!car) return;
  setLocalStorage('autoclinicConfirmedVehicle', JSON.stringify(car));
  renderConfirmedPopupVehicle();
}

const observedConfirmedPopupSelectors = new WeakSet();

function renderConfirmedPopupVehicle() {
  seedConfirmedPopupVehicle();
  const car = readConfirmedPopupVehicle();
  const selectionComplete = Boolean(getCompletePopupVehicle());
  const selectionCleared = ['brand', 'model', 'engine'].every(key =>
    !getLocalStorage(key).trim()
  );

  document.querySelectorAll('jsc-popup-select').forEach(selector => {
    // The theme updates aria-expanded for mouse and keyboard dropdown actions.
    if (!observedConfirmedPopupSelectors.has(selector)) {
      const observer = new MutationObserver(renderConfirmedPopupVehicle);
      observer.observe(selector, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-expanded']
      });
      observedConfirmedPopupSelectors.add(selector);
    }

    const dropdownOpen = Boolean(selector.querySelector(
      '.custom-select__btn[aria-expanded="true"]'
    ));
    const showConfirmedValue = Boolean(car) && !selectionCleared && (dropdownOpen || !selectionComplete);

    ['brand', 'model', 'engine'].forEach(key => {
      const label = selector.querySelector(`#jsc-${key}-label`);
      if (!label) return;

      // Keep the existing label and its ID (used by the dropdown's ARIA label).
      if (!label.hasAttribute('data-confirmed-base-label')) {
        label.setAttribute('data-confirmed-base-label', label.textContent.trim().replace(/:\s*$/, ''));
      }
      const baseLabel = label.getAttribute('data-confirmed-base-label');
      label.textContent = showConfirmedValue ? `${baseLabel}: ` : baseLabel;
      if (!car) return;

      const value = document.createElement('em');
      value.className = 'jsc-confirmed-vehicle-value';
      value.style.cssText = 'color:red;font-style:italic;overflow-wrap:anywhere;';
      value.style.display = showConfirmedValue ? '' : 'none';
      value.textContent = key === 'engine' ? car.engine.split('--').join('-') : car[key];
      label.appendChild(value);
    });
  });
}


/* =========================================================
   05. INITIAL PAGE LOAD
========================================================= */

// One initialization pass, after both the document and vehicle data are ready.
function initializeVehiclePage() {
  fetchCarDb().then(() => {
    const stages = [
      ['vehicle index', () => { indexedCarDb = indexCarDb(cachedCarDb); }],
      ['market vehicle selection', autoclinicClearHiddenMakeSelection],
      ['confirmed labels', renderConfirmedPopupVehicle],
      ['URL vehicle', autoSelectCarFromURL],
      ['vehicle ID', syncSelectedCarId],
      ['saved dropdowns', () => {
        onloadPopulateCarFilterFromLocalStorage();
        const savedSelection = ['brand', 'model', 'engine'].map(getLocalStorage).join('\u0000');
        window.setTimeout(() => {
          if (savedSelection !== ['brand', 'model', 'engine'].map(getLocalStorage).join('\u0000')) return;
          onloadPopulateCarFilterFromLocalStorage();
        }, 300);
      }],
      ['compatibility', checkCompatibility],
      ['compatibility table', onLoadCreateCompatibleTable],
      ['specifications', onLoadShowSpecificationContent],
      ['category links', appendFilterPageLinkList],
      ['part links', appendFilterPageLinks],
      ['selected vehicle display', refreshSelectedCarUIFromStorage]
    ];
    let failed = false;
    try {
      stages.forEach(([name, run]) => {
        try { run(); } catch (error) { failed = true; console.error('Vehicle page: ' + name, error); }
      });
      if (!failed) $('.autoclinic-page-status').remove();
      if (failed && $('#jsc-template').val() === 'page.filter') {
        showVehiclePageError('Some vehicle results could not load. Please reload to try again.');
      }
    } finally { $('.jsc-loader-overlay').hide(); }
  }, error => {
    console.error('Vehicle page data failed:', error);
    $('.jsc-loader-overlay').hide();
    if ($('#jsc-template').val() === 'page.filter') showVehiclePageError('Vehicle results could not load. Please reload to try again.');
  });
}
function showVehiclePageError(message) {
  let status = document.querySelector('.autoclinic-page-status');
  if (!status) {
    status = document.createElement('p');
    status.className = 'autoclinic-page-status';
    status.setAttribute('role', 'status');
    const main = document.querySelector('main');
    if (main) main.prepend(status);
  }
  status.textContent = message;
}
$(initializeVehiclePage);

/* =========================================================
   06. PRODUCT LINKS WITH carId
========================================================= */

/* Dynamic carID */
document.addEventListener("DOMContentLoaded", function () {
    let updateQueued = false;

    function getProductLinks() {
        return Array.from(
            document.querySelectorAll(
                '.jsc-product-grid .card-link, .jsc-product-grid .js-prod-link'
            )
        ).filter(link => !link.closest('.sale-content'));
    }

    function getCarIdFromLocalStorage() {
        const selected = getSelectedVehicleRecord();
        return selected ? selected.carId : null;
    }

    function updateProductLinksWithCarId() {
        updateQueued = false;

        // Do not disable or modify links until the car database is ready.
        if (!cachedCarDb || !cachedCarDb.length) return;

        const carId = getCarIdFromLocalStorage();
        if (!carId) return;

        getProductLinks().forEach(link => {
            const href = link.getAttribute('href');
            if (!href) return;

            try {
                const url = new URL(href, window.location.origin);
                url.searchParams.set('carId', carId);

                link.setAttribute(
                    'href',
                    url.pathname + url.search + url.hash
                );

                link.classList.remove('disabled-link');
                link.removeAttribute('aria-disabled');
                link.style.pointerEvents = '';
                link.style.opacity = '';
            } catch (error) {
                console.warn('Unable to append carId:', href, error);
            }
        });
    }

    function queueProductLinkUpdate() {
        if (updateQueued) return;
        updateQueued = true;
        requestAnimationFrame(updateProductLinksWithCarId);
    }

    // Run only after the database is ready.
    fetchCarDb().then(() => {
        queueProductLinkUpdate();
    });

    window.addEventListener('autoclinic:vehicle-id-updated', queueProductLinkUpdate);

    // Catch products added by infinite scroll or AJAX filters.
    const observer = new MutationObserver(mutations => {
        const hasAddedProducts = mutations.some(mutation =>
            Array.from(mutation.addedNodes).some(node =>
                node.nodeType === 1 &&
                (
                    node.matches?.('.js-pagination-result, product-card') ||
                    node.querySelector?.('.card-link, .js-prod-link, product-card')
                )
            )
        );

        if (hasAddedProducts) {
            queueProductLinkUpdate();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Fallback after collection filtering or pagination actions.
    document.addEventListener('click', function (event) {
        if (event.target.closest('.filter-option, custom-pagination, [data-filter]')) {
            setTimeout(queueProductLinkUpdate, 150);
        }
    });
});
/* End */



var loader = $('.jsc-loader-overlay');

var blankLi = `<li class="custom-select__option flex items-center js-option" id="jsc-brand-blank" role="option" data-value="Loading..."><span class="pointer-events-none">Loading...</span></li>`;

const carDbColumn = ['coilovers', 'heightAdjustableSprings', 'loweringSprings', 'electronicCancellerKit', 'undercarriageArms', 'sportsDiscAndPads', 'brakeSystems', 'airFilter (dropIn)', 'airFilter (openPodSystem)', 'ecuPiggyback (euroCars)', 'ecuPiggyback2 (euroCars)', 'ecuPiggyback (nonEuro)', 'throttleController', 'ecuTuning', 'blowOff /DiverterValves', 'cooling', 'sparkPlug /IgnitionCoil', 'fuel', 'turbo /Supercharger', '1PieceWheel', '2PieceWheel', 'roadCompliantSystem (withCertification)', 'racingSystem (noCertification)', 'autoclinic', 'akrapovic', 'apr', 'dte', 'fox', 'gfb', 'kw', 'st', 'remus', 'completeCarTuningProgram']; // Add more link types here



/* =========================================================
   07. MAIN DOCUMENT READY INITIALIZATION
========================================================= */

$(function () {
   renderConfirmedPopupVehicle();
   restoreVehicleDropdownText();
   $('.jsc-model .custom-select__btn, .jsc-engine .custom-select__btn').prop('disabled', true).attr('aria-busy', 'true');
   initLoader();
   onLoadFunctionInit();
   if (location.pathname.includes('/products')) {
      addOnsCheck(exhaustDb);
      calculateTotalAmount();
   }
   $('.jsc-brand .custom-select__btn').prop('disabled', true).attr('aria-busy', 'true');
   $('.jsc-brand').each(function () {
      if (!this.querySelector('.autoclinic-data-status')) {
         const status = document.createElement('small');
         status.className = 'autoclinic-data-status';
         status.setAttribute('role', 'status');
         status.textContent = 'Loading vehicle data…';
         this.appendChild(status);
      }
   });
   fetchCarDb().then(() => {
      onloadPopulateCarFilterFromLocalStorage();
   }, () => {
      $('.jsc-model .custom-select__btn, .jsc-engine .custom-select__btn').removeAttr('aria-busy');
      $('.autoclinic-data-status').text('Vehicle options could not load. Please reload to try again.');
   });
   fetchBrandrDb().then(() => {
      loadBrandOption();
      restoreVehicleDropdownText();
      $('.jsc-brand .custom-select__btn').prop('disabled', false).removeAttr('aria-busy');
      $('.autoclinic-data-status').remove();
      if (location.pathname == '/') {
         loader.hide();
      }
   }, function (error) {
      $('.autoclinic-data-status').text('Vehicle selector could not initialize. Please reload to try again.');
      console.error('Vehicle selector initialization failed:', error);
   }); 

   // 👉 Add here (this runs after brand/model lists are loaded)
   document.querySelectorAll(".search-brand, .search-model, .search-engine").forEach(input => {
      const parent = input.closest(".custom-select, .jsc-brand, .jsc-model, .jsc-engine");
      if (!parent) return;
      const dropdown = parent.querySelector(".custom-select__listbox");
      if (!dropdown) return;

      let debounceTimer;
      input.addEventListener("input", () => {
         clearTimeout(debounceTimer);
         debounceTimer = setTimeout(() => {
         const query = input.value.trim().toLowerCase();
         const options = dropdown.querySelectorAll(".custom-select__option");
         if (!options.length) return;

         let matchFound = false;
         options.forEach(option => {
            const match = option.textContent.toLowerCase().includes(query);
            option.style.display = match || query === "" ? "" : "none";
            if (match) matchFound = true;
         });

         dropdown.hidden = !matchFound && query !== "";
         }, 100);
      });
   });

   initMultiColumnSwiper();
});

onLoadFunctionInit = () =>{
   loadMyCarModel();
   loadHeaderCarInfo();
   appendURLFilterParamAsHiddenInputInCPFilter();
   hideCPFilterOption();
   hideCpFilterWhenEmpty();
   loadCarInfoToLIProperties();
   selectAndStoreRandomGridElements();
   loadUpsellGrid();
   onloadDateRange();
}

selectAndStoreRandomGridElements = () => {
   // Step 1: Select all elements with the class 'jsc-product-grid'
   var elements = $('.jsc-product-grid').toArray();

   if (elements.length > 1) {
      // Step 2: Shuffle the array
      function shuffle(array) {
         for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
         }
         return array;
      }

      var shuffledElements = shuffle(elements);

      // Step 3: Pick the first three elements
      var selectedElements = shuffledElements.slice(0, 3);

      // Step 4: Store their indices in local storage
      var selectedIndices = selectedElements.map(function(elem) {
         return elem.outerHTML;
      });

      localStorage.setItem('selectedProducts', JSON.stringify(selectedIndices));
      localStorage.setItem('upsellCollectionSelected', $('#jsc-collection-handle').val());
   }
}

loadUpsellGrid = () =>{
   var gridHTML = getLocalStorage('selectedProducts');
   var upsellCollection = getLocalStorage('upsellCollectionSelected');
   var productCollectionHandles = $('#jsc-product-colecttion-handles').val();

   if (productCollectionHandles) {
      if (gridHTML && productCollectionHandles.includes(upsellCollection)) {
         var currentProductHandle = $('#jsc-product-handles').val();
         var htmlArray = JSON.parse(gridHTML);
         var count = 0;
         htmlArray.forEach(element => {
            var _thisProductHandle = $(element).attr('data-handle');
            if (currentProductHandle != _thisProductHandle && count < 2) {
               $('jsc-upssell ul').append(element);
               count++;
            }
         });
         $('jsc-upssell .jsc-section-title').show();
      }
   }
}

initLoader = () => {
   const resultsPage = $('#jsc-template').val() === 'page.filter' || /\/pages\/my-car-model\/?$/.test(window.location.pathname);
   if (resultsPage) loader.show();
   else loader.hide();
}

handleizedString = (string) => {
   return string.replace(/\s+/g, '-').replace(/\//g, '-').trim().toLowerCase().replace('(', '-').replace(')', '-').replace(/--/g, '-').replace('.', '-');
}



/* =========================================================
   08. CAR SELECTOR DROPDOWN OPTIONS
========================================================= */

// Index once per dataset; cache each make's model markup for repeat selection.
let dropdownSource = null;
let dropdownModels = new Map();
let dropdownModelHtml = new Map();
function escapeDropdownValue(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[character]);
}
function modelOptionMarkup(model, selectedModel) {
  const selected = model === selectedModel;
  return `<li class="custom-select__option text-left flex items-center js-option ${selected ? 'active-selected' : ''}" id="jsc-model-${escapeDropdownValue(handleizedString(model))}" role="option" data-value="${escapeDropdownValue(model)}" onclick="selectOption(this,'model')" aria-selected="${selected}"><span class="pointer-events-none">${escapeDropdownValue(model)}</span></li>`;
}
function prepareDropdownIndex(rows) {
  if (dropdownSource === rows) return;
  dropdownSource = rows;
  dropdownModels = new Map();
  dropdownModelHtml = new Map();
  for (const row of rows || []) {
    if (!dropdownModels.has(row.make)) dropdownModels.set(row.make, new Set());
    dropdownModels.get(row.make).add(row.model);
  }
  // Build markup only for the make actually opened, not every make at startup.
}
populateModelHtml = (jsonData, brand, localStorageModel) => {
   prepareDropdownIndex(jsonData);
   if (!dropdownModelHtml.has(brand)) {
     dropdownModelHtml.set(brand, [...(dropdownModels.get(brand) || [])].sort().map(model => modelOptionMarkup(model)).join(''));
   }
   const markup = localStorageModel
     ? [...(dropdownModels.get(brand) || [])].sort().map(model => modelOptionMarkup(model, localStorageModel)).join('')
     : dropdownModelHtml.get(brand) || '';
   const lists = document.querySelectorAll('.jsc-model .custom-select__listbox');
   lists.forEach(list => {
     list.classList.remove('hide');
     list.hidden = true;
     // Reuse the existing list if this make is already rendered in this selector.
     if (list.dataset.autoclinicMake !== brand || list.dataset.autoclinicSelectedModel !== (localStorageModel || '') || list._autoclinicSource !== jsonData || list.firstElementChild?.dataset.value === 'Loading...') {
       list.innerHTML = markup;
       list.dataset.autoclinicMake = brand;
       list.dataset.autoclinicSelectedModel = localStorageModel || '';
       list._autoclinicSource = jsonData;
       // The theme retains references to old options after dynamic list updates.
       const control = list.closest('custom-select');
       if (control) {
         control.options = list.querySelectorAll('.custom-select__option');
         control.selectedOption = list.querySelector('[aria-selected="true"]') || list.firstElementChild;
         control.focusedOption = null;
       }
     }
   });
   $('.jsc-model .custom-select__btn').addClass('jsc-enabled-dropdown').prop('disabled', false).removeAttr('aria-busy');
}

populateEngineHtml = (jsonData, model, localStorageEngine) => {
   // Filter the JSON data for the selected "Model"
   var filteredData = jsonData.filter(function(item) {
      return item.model === model;
   });

   var engineUlElement = $('.jsc-engine .custom-select__listbox');

   // New Version
   // Get these 3 ('carName', 'power(kW)', 'ccm', 'cyl') values and concatenate into a string and append into the Engine dropdown
   var uniqueEngineOptions = new Set();
   var keysToMap = ['carName', 'power(kW)', 'cyl', 'drivetype'];
   var engineOptions = [...new Set(filteredData.map(item => keysToMap.map(key => item[key])))].sort().map(values => {
      var joinedValues = values.join('-');
      if (!uniqueEngineOptions.has(joinedValues)) {
         uniqueEngineOptions.add(joinedValues);
         return `<li class="custom-select__option text-left flex items-center js-option ${values.join('--') == localStorageEngine ? 'active-selected' : ''}" id="jsc-engine-${values.join('-')}" role="option" data-value="${values.join('--')}" onclick="selectOption(this,'engine')" ${values.join('--') == localStorageEngine ? 'aria-selected="true"' : 'aria-selected="false"'}>
                  <span class="pointer-events-none">${values.join('-')}</span>
               </li>`;
      }
   });

   engineUlElement.removeClass('hide').attr('hidden', true).html(engineOptions.join(''));
   syncVehicleDropdownControls('engine');

   $('.jsc-engine .custom-select__btn').addClass('jsc-enabled-dropdown');
   $('.jsc-engine').find('.custom-select__btn').prop('disabled', false).removeAttr('aria-busy');
}

loadBrandOption = () => {
   if (!brandDb || !brandDb.length) return;
   // The make list can render independently of the full fitment database.
   var getBrandLocalStorage = getLocalStorage('brand');
   var carDb = brandDb;
   // Populate the "Brand" dropdown
   var brandUlElement = $('.jsc-brand .custom-select__listbox');

   // Get unique brands, sort them alphabetically, and map to HTML options
   var brandOptions = [...new Set(carDb.map(item => item.brand))]
      .filter(brand => !autoclinicHiddenMake(brand))
      .sort((a, b) => a.localeCompare(b)) // Sort brands alphabetically
      .map(brand => {
         var handleizedBrand = handleizedString(brand);
         return `<li class="custom-select__option flex items-center js-option ${brand == getBrandLocalStorage ? 'active-selected' : ''}" id="jsc-brand-${handleizedBrand}" role="option" data-value="${brand}" onclick="selectOption(this,'brand')" ${brand == getBrandLocalStorage ? 'aria-selected="true"' : 'aria-selected="false"'}>
                     <span class="pointer-events-none">${brand}</span>
                 </li>`;
      });

   // Update the dropdown with sorted options
   brandUlElement.html(brandOptions.join(''));
   syncVehicleDropdownControls('brand');
};

let autoclinicMakeRequest = 0;
loadModelOption = (brand) => {
   const request = ++autoclinicMakeRequest;
   // A repeat selection of the saved make must not erase its model/engine.
   // selectOption clears dependent values only when the make really changes.
   setLocalStorage('brand', brand);
   if (!Array.isArray(cachedCarDb) || !cachedCarDb.length) {
      $('.jsc-model .custom-select__btn, .jsc-engine .custom-select__btn')
         .prop('disabled', true).attr('aria-busy', 'true');
      restoreVehicleDropdownText();
      fetchCarDb().then(() => {
         if (request !== autoclinicMakeRequest || getLocalStorage('brand') !== brand) return;
         onloadPopulateCarFilterFromLocalStorage();
      }, () => {
         if (request !== autoclinicMakeRequest) return;
         $('.jsc-model .custom-select__btn, .jsc-engine .custom-select__btn').removeAttr('aria-busy');
         $('.autoclinic-data-status').text('Vehicle options could not load. Please reload to try again.');
      });
      return;
   }
   onloadPopulateCarFilterFromLocalStorage();
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".search-brand, .search-model, .search-engine").forEach(input => {
    ["keydown", "keyup", "keypress"].forEach(eventName => {
      input.addEventListener(eventName, function (e) {
        if (e.key === " " || e.code === "Space") {
          e.stopPropagation();
        }
      });
    });

    input.addEventListener("click", e => e.stopPropagation());
    input.addEventListener("mousedown", e => e.stopPropagation());
  });

  const normalizeSearchText = (value) => {
    return String(value || "")
      .toLowerCase()
      .replace(/\s+/g, "");
  };

  const filterDropdown = (searchInputSelector, dropdownSelector) => {
    const searchInput = document.querySelector(searchInputSelector);
    if (!searchInput) return;

    let debounceTimer;
    const safeFilter = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const dropdown = document.querySelector(dropdownSelector);
        if (!dropdown) return;

        const rawQuery = searchInput.value.trim().toLowerCase();
        const query = normalizeSearchText(rawQuery);
        const options = dropdown.querySelectorAll(".custom-select__option");
        if (!options.length) return;

        let matchFound = false;
        options.forEach(option => {
          const text = option.textContent.trim();
          const match =
            normalizeSearchText(text).includes(query) ||
            text.toLowerCase().includes(rawQuery);

          option.style.display = match || rawQuery === "" ? "" : "none";
          if (match) matchFound = true;
        });

        if (rawQuery === "" || matchFound) {
          dropdown.classList.remove("hide");
          dropdown.removeAttribute("hidden");
        } else {
          dropdown.classList.add("hide");
          dropdown.setAttribute("hidden", true);
        }
      }, 100);
    };

    searchInput.addEventListener("input", safeFilter);
    searchInput.addEventListener("keyup", (e) => {
      if (e.key === "Backspace" || e.key === "Delete") safeFilter();
    });
  };

  filterDropdown(".search-brand", ".jsc-brand .custom-select__listbox");
  filterDropdown(".search-model", ".jsc-model .custom-select__listbox");
  filterDropdown(".search-engine", ".jsc-engine .custom-select__listbox");
});

loadEngineOption = (model) => {
   var carDb = cachedCarDb;

   populateEngineHtml(carDb, model);

   resetEngineOption();

   // reset local storage
   setLocalStorage('engine', '');
}

resetBrandOption = () => {
   $('.jsc-brand .custom-select__btn span.text-start').text('Brand...');
   $('.jsc-brand').find('.jsc-check-mark').hide();
   $('.jsc-popup-warning').show();
   $('.find-parts').removeAttr('href');
   $('.find-parts').attr('aria-disabled', true);
   $('button[name="checkout"]').attr('disabled', true);
   $('.dynamic-cart-btns').css('display', 'none');
}

resetModelOption = () => {
   $('.jsc-model .custom-select__btn span.text-start').text('Model...');
   $('.jsc-model').find('.jsc-check-mark').hide();
   $('.jsc-popup-warning').show();
   $('.find-parts').removeAttr('href');
   $('.find-parts').attr('aria-disabled', true);
   $('button[name="checkout"]').attr('disabled', true);
   $('.dynamic-cart-btns').css('display', 'none');
}

resetEngineOption = () => {
   $('.jsc-engine .custom-select__btn span.text-start').text('Engine...');
   $('.jsc-engine').find('.jsc-check-mark').hide();
   $('.jsc-popup-warning').show();
   $('.find-parts').removeAttr('href');
   $('.find-parts').attr('aria-disabled', true);
   $('button[name="checkout"]').attr('disabled', true);
   $('.dynamic-cart-btns').css('display', 'none');
}



/* =========================================================
   09. CAR SELECTION / RESET LOGIC
========================================================= */

selectOption = (e, key) => {
    // Capture the previous complete selection before changing any draft keys.
    renderConfirmedPopupVehicle();
    var _this = $(e);
    var value = _this.attr('data-value');
    if (key === 'brand' && autoclinicHiddenMake(value)) return;

    // Update selected option state
    _this
     .siblings('.custom-select__option')
     .removeClass('active-selected')
     .attr('aria-selected', 'false');

    _this
     .addClass('active-selected')
     .attr('aria-selected', 'true');

    // Only a deliberate change of parent invalidates dependent saved values.
    const previousValue = getLocalStorage(key);
    if (key === 'brand' && previousValue !== value) {
      setLocalStorage('model', '');
      setLocalStorage('engine', '');
      resetModelOption();
      resetEngineOption();
      $('.jsc-model .custom-select__btn, .jsc-engine .custom-select__btn').prop('disabled', true);
      $('.jsc-model .custom-select__listbox, .jsc-engine .custom-select__listbox').html(blankLi).attr('hidden', true);
    }
    // Set Local storage
    setLocalStorage(key, value);

    // The theme may already consider the first/only option selected and skip
    // its button update. Always display the value chosen in this handler.
    // Update every matching selector (popup and homepage) without changing
    // the separate labels that show the last fully confirmed vehicle.
    const selectedButtonText = key === 'engine' ? value.split('--').join('-') : value;
    $(`.jsc-${key} .custom-select__btn span.text-start`).text(selectedButtonText);

    // Enable checkmark
    enableCheckMark(key);

    // Enable model option
    if (key == 'brand') {
        loadModelOption(value);
    }

    // Enable engine option
    if (key == 'model' && previousValue !== value) {
        loadEngineOption(value);
    }

    // If Engine is selected, fetch and log the Car ID

    if (key == 'engine') {
      $('.jsc-popup-warning').hide();

      const marketPrefix = autoclinicMarketPrefix();

      const filterPage = "/pages/my-car-model";
      const destination = new URL(marketPrefix + filterPage, window.location.origin);
      const vehicle = getSelectedVehicleRecord();
      if (vehicle) destination.searchParams.set('carId', String(vehicle.carId));
      const finalHref = destination.pathname + destination.search;

      $('.find-parts').attr('href', finalHref);
      $('.find-parts').attr('aria-disabled', false);
      $('button[name="checkout"]').attr('disabled', false);
      $('.dynamic-cart-btns').css('display', 'block');

      saveCarDetails(value); // This function saves car details

      // Fetch and log Car ID immediately
      fetchAndLogCarId();

      // Apply the vehicle SKU filter to this collection without confirmation.
      refreshCollectionAfterVehicleSelection();
    }

    // Refresh label visibility after draft keys or the completed vehicle change.
    renderConfirmedPopupVehicle();
}

const fetchAndLogCarId = () => {
  var brand = getLocalStorage('brand');
  var model = getLocalStorage('model');
  var engine = getLocalStorage('engine');

  if (!brand || !model || !engine || !cachedCarDb || cachedCarDb.length === 0) return;

  var engineArray = engine.split('--');

  var selectedCar = cachedCarDb.find(car =>
    normalize(car.make) === normalize(brand) &&
    normalize(car.model) === normalize(model) &&
    normalize(car.carName) === normalize(engineArray[0]) &&
    normalize(car['power(kW)']) === normalize(engineArray[1]) &&
    normalize(car.cyl) === normalize(engineArray[2]) &&
    normalize(car.drivetype) === normalize(engineArray[3])
  );

  if (!selectedCar || !selectedCar.carId) return;

  localStorage.setItem("previousCarId", selectedCar.carId);

  const url = new URL(window.location.href);
  url.searchParams.set("carId", selectedCar.carId);
  window.history.replaceState({}, "", url.toString());

  syncSelectedCarId();
  loadHeaderCarInfo();
  loadCarInfoToLIProperties();
  checkCompatibility();
};

setLocalStorage = (key, value) => {
   localStorage.setItem(key, value);
}

getLocalStorage = (key) => {
   const value = localStorage.getItem(key);
   return value === null || value === '' ? '' : value;
}

function refreshSelectedCarUIFromStorage() {
  renderConfirmedPopupVehicle();
  loadMyCarModel();
  loadHeaderCarInfo();
  loadCarInfoToLIProperties();
  onloadPopulateCarFilterFromLocalStorage();
  checkCompatibility();
}

saveCarDetails = (engineValue) =>{
   var getBrandLocalStorage = getLocalStorage('brand');
   var getModelLocalStorage = getLocalStorage('model');
   var engineValueArray = engineValue.split('--');
   var axleFa = [];
   var axleRa = [];
   var contentOfDelivery = [];
   var vehicleHasElectronicDamper = [];
   var noteProduct = [];
   var diameterFa = [];
   var strutDiameterFrontAxle = [];
   var rearAxleType = [];
   var noteCar = [];
   var frontAxleStruts = [];

   var carDb = cachedCarDb;

   // Filter the JSON data for the selected "Brand"
   var filteredData = carDb.filter(function(item) {
      return item.make === getBrandLocalStorage && item.model == getModelLocalStorage && item.carName === engineValueArray[0] && item['power(kW)'] === engineValueArray[1] && item.cyl === engineValueArray[2] && item.drivetype === engineValueArray[3];
   });

   for (let i = 0; i < filteredData.length; i++) {
      const element = filteredData[i];
      axleFa.push(element['axleLoadFa (kg)']);
      axleRa.push(element['axleLoadRa (kg)']);
      contentOfDelivery.push(element['contentOfDelivery']);
      vehicleHasElectronicDamper.push(element['vehicleHasElectronicDamper']);
      noteProduct.push(element['note (product)']);
      diameterFa.push(element['diameterFa (mm)']);
      strutDiameterFrontAxle.push(element['strutDiameterFrontAxle (mm)']);
      rearAxleType.push(element['rearAxleType']);
      noteCar.push(element['note (carAssignment)']);
      frontAxleStruts.push(element['frontAxleStruts']);
   }

   setLocalStorage('axle weight fa', Array.from(new Set(axleFa)));
   setLocalStorage('axle weight ra', Array.from(new Set(axleRa)));
   setLocalStorage('content of delivery', Array.from(new Set(contentOfDelivery)));
   setLocalStorage('vehicle has electronic damper', Array.from(new Set(vehicleHasElectronicDamper)));
   setLocalStorage('note (product)', Array.from(new Set(noteProduct)));
   setLocalStorage('diameter fa (mm)', Array.from(new Set(diameterFa)));
   setLocalStorage('strut diameter front axle (mm)', Array.from(new Set(strutDiameterFrontAxle)));
   setLocalStorage('rear axle type', Array.from(new Set(rearAxleType)));
   setLocalStorage('note (car assignment)', Array.from(new Set(noteCar)));
   setLocalStorage('front axle struts', Array.from(new Set(frontAxleStruts)));

   // Engine selection and URL auto-selection both complete through this path.
   confirmPopupVehicle(engineValue);
}

disabledAllSelection = () => {
   document.querySelectorAll('.jsc-model .custom-select__listbox').forEach(list => {
      delete list.dataset.autoclinicMake;
      delete list.dataset.autoclinicSelectedModel;
      list._autoclinicSource = null;
   });
   // Model
   $('.jsc-model .custom-select__btn').removeClass('jsc-enabled-dropdown');
   $('.jsc-model .custom-select__listbox').addClass('hide').attr('hidden', false).html(blankLi);
   $('.jsc-model').find('.custom-select__btn').prop('disabled', true);

   // Engine
   $('.jsc-engine .custom-select__btn').removeClass('jsc-enabled-dropdown');
   $('.jsc-engine .custom-select__listbox').addClass('hide').attr('hidden', false).html(blankLi);
   $('.jsc-engine').find('.custom-select__btn').prop('disabled', true);

   // reset local storage
   setLocalStorage('brand', '');
   setLocalStorage('model', '');
   setLocalStorage('engine', '');
}

clearSelection = () => {
   ++autoclinicMakeRequest;
   resetBrandOption();
   resetModelOption();
   resetEngineOption();

   disabledAllSelection();
   localStorage.removeItem('autoclinicConfirmedVehicle');
   renderConfirmedPopupVehicle();
}

// Restore saved text before the network request finishes. Never clear storage here.
function restoreVehicleDropdownText() {
  ['brand', 'model', 'engine'].forEach(key => {
    const value = getLocalStorage(key);
    if (value) {
      $(`.jsc-${key} .custom-select__btn span.text-start`).text(
        key === 'engine' ? value.replaceAll('--', '-') : value
      );
    }
  });
}

// Dynamic lists must replace the theme's references to the old placeholder options.
function syncVehicleDropdownControls(key) {
  document.querySelectorAll(`.jsc-${key} .custom-select__listbox`).forEach(list => {
    const control = list.closest('custom-select');
    if (!control) return;
    control.options = list.querySelectorAll('.custom-select__option');
    control.selectedOption = list.querySelector('[aria-selected="true"]') || list.firstElementChild;
    control.focusedOption = null;
  });
}

onloadPopulateCarFilterFromLocalStorage = () => {
  restoreVehicleDropdownText();
  if (!Array.isArray(cachedCarDb) || !cachedCarDb.length) return;
  var getBrandLocalStorage = getLocalStorage('brand');
  var getModelLocalStorage = getLocalStorage('model');
  var getEngineLocalStorage = getLocalStorage('engine');

  var carDb = cachedCarDb;
  $('.jsc-model .custom-select__btn, .jsc-engine .custom-select__btn').removeAttr('aria-busy');

  if (getBrandLocalStorage) {
    // Load Model option if Brand is in local storage
    populateModelHtml(carDb, getBrandLocalStorage, getModelLocalStorage);

    // Styling changes to brand dropdown
    enableCheckMark('brand');
    $('.jsc-brand .custom-select__btn span.text-start').text(getBrandLocalStorage);
  }

  if (getModelLocalStorage) {
    // Load Engine option if Model is in local storage
    populateEngineHtml(carDb, getModelLocalStorage, getEngineLocalStorage);

    // Styling changes to model dropdown
    enableCheckMark('model');
    $('.jsc-model .custom-select__btn span.text-start').text(getModelLocalStorage);
  }

  if (getEngineLocalStorage) {
    // Styling changes to engine dropdown
    enableCheckMark('engine');
    $('.jsc-engine .custom-select__btn span.text-start').text(getEngineLocalStorage.replaceAll('--', '-'));
    $('.jsc-popup-warning').hide();

    const marketPrefix = autoclinicMarketPrefix();

    const filterPage = '/pages/my-car-model';
    const finalHref = marketPrefix + filterPage;

    $('.find-parts').attr('href', finalHref);
    $('.find-parts').attr('aria-disabled', false);

    $('button[name="checkout"]').attr('disabled', false);
    $('.dynamic-cart-btns').css('display', 'block');
  }
  ['brand', 'model', 'engine'].forEach(key => {
    const saved = getLocalStorage(key);
    document.querySelectorAll(`.jsc-${key} .custom-select__listbox .custom-select__option`).forEach(option => {
      const selected = Boolean(saved) && option.getAttribute('data-value') === saved;
      option.setAttribute('aria-selected', String(selected));
      option.classList.toggle('active-selected', selected);
    });
    syncVehicleDropdownControls(key);
  });
}

enableCheckMark = (key) => {
   $(`#jsc-${key}`).find('.jsc-check-mark').show();
}

changeVehicleTrigger = (e, triggerFrom) => {
   // Open first: openCarPopup chooses the saved-car summary by default.
   // Apply edit mode afterward so it cannot overwrite this requested view.
   if (triggerFrom === 'page') openCarPopup(e);
   onloadPopulateCarFilterFromLocalStorage();
   renderConfirmedPopupVehicle();
   carPopupScrollY = window.scrollY || document.documentElement.scrollTop || 0;
   $('jsc-popup-my-model').hide();
   $('jsc-popup-select').show();
   $('body').addClass('model-open');
   $('.jsc-popup-header').text('Select Your Vehicle');
}


/* =========================================================
   10. SELECTED VEHICLE UI / POPUP DISPLAY
========================================================= */

loadMyCarModel = () =>{
   var brandName = getLocalStorage('brand');
   var modelValue = getLocalStorage('model');
   var engineValue = getLocalStorage('engine');
   if (brandName && modelValue && engineValue) {
      var html = `<div class="jsc-my-model-detail-brand-model">
                  <span class="h6">${brandName} ${modelValue}</span>
               </div>
               <div class="jsc-my-model-detail-engine">
                  <span>${engineValue}</span>
               </div>`;

      var html2 = `<div class="custom-model-detail jsc-my-model-detail">
                     <span class="fontWeight-9">Products compatible for: <span class="mobile-only"></span> ${brandName} ${modelValue}</span>
                     <span>${engineValue}</span>
                  </div>`;

      // Append selected option into my car model section
      $('.jsc-my-model-detail').html(html);

      // Append selected option into my car model section v2
      $('.jsc-my-model-detail-v2').html(html2);

      // Only hide selector when popup has selected-car content available
      if ($('jsc-popup-my-model').length) {
         $('jsc-popup-select').hide();
         $('jsc-popup-my-model').show();
         $('.jsc-popup-header').text('Search parts for my vehicle');
      } else {
         $('jsc-popup-select').show();
         $('.jsc-popup-header').text('Select Your Vehicle');
      }
   } else {
      $('jsc-popup-my-model').hide();

   }
}
loadHeaderCarInfo = () =>{
   var brandName = getLocalStorage('brand');
   var modelValue = getLocalStorage('model');
   var engineValue = getLocalStorage('engine');

   if (brandName && modelValue && engineValue){
      var brandNameAndModel = `${brandName} ${modelValue}`;
      var brandNameAndModel2 = `${brandName} ${modelValue} ${engineValue}`;
      $('.jsc-header-car-title').text(brandNameAndModel);
      $('.menu-jsc-header-car-title').text(brandNameAndModel2);
   }
}
let carPopupScrollY = 0;

function openCarPopup(e) {
  renderConfirmedPopupVehicle();
  if (e && e.preventDefault) {
    e.preventDefault();
    e.stopPropagation();
  }

  carPopupScrollY = window.scrollY || document.documentElement.scrollTop || 0;

  // Finish a pending fade before reopening so it cannot hide the popup later.
  getCarModalElements().stop(true, true).show();
  $('body').addClass('model-open');

  // Opening an overlay must not schedule a later scroll that overrides the user.

  const hasCar =
    getLocalStorage('brand') &&
    getLocalStorage('model') &&
    getLocalStorage('engine');

  if (hasCar) {
    $('jsc-popup-select').hide();
    $('jsc-popup-my-model').show();
    $('.jsc-popup-header').text('Search parts for my vehicle');
  } else {
    $('jsc-popup-select').show();
    $('jsc-popup-my-model').hide();
    $('.jsc-popup-header').text('Select Your Vehicle');
  }
}

/* =========================================================
   11. COMPATIBILITY TABLE
========================================================= */

onLoadCreateCompatibleTable = () => {
   const campatibilityTableContainer = $('#compatiblility-table');
   if (!campatibilityTableContainer.length) return;

   // Retrieve SKU filter from URL
   const urlParams = new URLSearchParams(window.location.search);
   const pageSku = campatibilityTableContainer.attr('data-sku') || $('#jsc-specification').attr('data-sku');
   const skuFilters = pageSku ? uniqueSkus([pageSku]) : uniqueSkus(urlParams.getAll(SKU_FILTER_PARAM));

   if (!skuFilters.length) {
       campatibilityTableContainer.parents('.jsc-section').hide();
       return;
   }

   // Clear all existing product entries in the table to start fresh
   const tbody = campatibilityTableContainer.find('tbody');
   tbody.empty();

   // Apply strict filtering based on the SKU field in cachedCarDb
   const filteredData = cachedCarDb.filter(element => skuFilters.some(sku => carMatchesSku(element, sku)));

   // If no items match the filter, hide the compatibility table section
   if (filteredData.length === 0) {
       campatibilityTableContainer.parents('.jsc-section').hide();
       return;
   }

   campatibilityTableContainer.parents('.jsc-section').show();

   // Generate table rows only for filtered items
   const tableHTMLArray = filteredData.map(element => 
       `<tr><td>${element.make}</td><td>${element.model}</td><td>${element.carName}</td>
       <td>${element.chassis}</td><td>${element.aspiration}</td><td>${element['power(kW)']}</td>
       <td>${element.ccm}</td><td>${element.cyl}</td><td>${element.drivetype}</td></tr>`
   );

   // Append filtered results to the table
   tableHTMLArray.forEach(row => tbody.append(row));
};

loadTableRow = (htmlArray, page) => {

    const campatibilityTableContainer = $('#compatiblility-table');
    if (!campatibilityTableContainer.length || htmlArray.length === 0) {
        campatibilityTableContainer.parents('.jsc-section').hide();
        return;
    }

    // Clear previous rows and pagination
    const tbody = campatibilityTableContainer.find('tbody');
    tbody.empty();
    campatibilityTableContainer.find('.jsc-pagination-pages').empty();

    const perPageLimit = 15;
    const totalPaginationNum = Math.ceil(htmlArray.length / perPageLimit);
    const arrayStartIndex = (page - 1) * perPageLimit;
    const arrayEndIndex = Math.min(page * perPageLimit, htmlArray.length);

    // Append rows to the table
    for (let index = arrayStartIndex; index < arrayEndIndex; index++) {
        tbody.append(htmlArray[index]);
    }

    // Update pagination
    updatePaginationIndex(totalPaginationNum, page, htmlArray);
};

// Function to update pagination index
updatePaginationIndex = (totalPage, activePage, htmlArray) => {
   const paginationContainer = $('#jsc-pagination-container');
   const paginationPages = paginationContainer.find('.jsc-pagination-pages');

   // Loop through the total number of pages
   for (let index = 1; index <= totalPage; index++) {
       // If it's the active page, add a current page class
       if (index === activePage) {
           paginationPages.append(`<span class="jsc-currentPage jsc-pagination-index m-l-10 m-r-10">${index}</span>`);
       } else {
           // Add pagination index with onclick function to paginate
           paginationPages.append(`<span class="jsc-pagination-index cursor m-l-10 m-r-10 " onclick="paginate('${htmlArray.join('---')}',${index})">${index}</span>`);
       }
   }
};

// Function to paginate and load new table rows
paginate = (htmlString, pageIndex) => {
   const campatibilityTableContainer = $('#compatiblility-table');
   const htmlArray = htmlString.split('---');

   // Remove existing table rows and pagination
   campatibilityTableContainer.find('tbody').children().remove();
   campatibilityTableContainer.find('.jsc-pagination-pages').children().remove();

   // Load new table rows with pagination
   loadTableRow(htmlArray, pageIndex);
};
// Compatibility Table ends here

// Specification tab starts here
/* =========================================================
   12. PRODUCT SPECIFICATIONS
========================================================= */

onLoadShowSpecificationContent = () => {
   const normalize = (val) => String(val || '').trim().toLowerCase();
   // Get selected car details from local storage
   const brand = getLocalStorage('brand');
   const model = getLocalStorage('model');
   const engine = getLocalStorage('engine');
   const engineArray = engine.split('--');

   // Get current PDP sku
   const specificationElement = $('#jsc-specification');
   const productSku = specificationElement.attr('data-sku');

   let specificationHtml = '';

   // Filter the product to match the current product sku and selected car filter from the Database
   const filteredData = cachedCarDb.filter((item) =>
      item.make === brand &&
      item.model === model &&
      normalize(item.carName) === normalize(engineArray[0]) &&
      item['power(kW)'] === engineArray[1] &&
      item.cyl === engineArray[2] &&
      item.drivetype === engineArray[3] &&
      carMatchesSku(item, productSku)
   );

   // Loop through the filtered data array
   filteredData.forEach(element => {
      //Build the HTML content
      specificationHtml += `<strong>Axle Load FA (kg):</strong>${element['axleLoadFa (kg)']}<br>
                           <strong>Axle Load RA (kg):</strong>${element['axleLoadRa (kg)']}<br>
                           <strong>Lowering FA (mm):</strong>${element['loweringFa (mm)']}<br>
                           <strong>Lowering RA (mm):</strong>${element['loweringRa (mm)']}<br>`;
   });

   // Append HTML to Specification section/tab/accordion
   specificationElement.append(specificationHtml);

}

const buildSkuParameter = (skuArray) => {
  const params = new URLSearchParams();
  uniqueSkus(skuArray).forEach(sku => params.append(SKU_FILTER_PARAM, sku));
  return params.toString();
};

onloadDateRange = () => {
   var today = new Date();
   var startDate = new Date(today);
   var startDay = parseInt($('.jsc-date-range').attr('data-start'));
   startDate.setDate(startDate.getDate() + startDay);
   var endDate = new Date(today);
   var endDay = parseInt($('.jsc-date-range').attr('data-end'));
   endDate.setDate(endDate.getDate() + endDay);

   var dd_start = String(startDate.getDate()).padStart(2, '0');
   var dd_end = String(endDate.getDate()).padStart(2, '0');
   var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
   var month_start = monthNames[startDate.getMonth()];
   var month_end = monthNames[endDate.getMonth()];
   var formattedStartDate = dd_start + ' ' + month_start;
   var formattedEndDate = dd_end + ' ' + month_end;

   $('.jsc-range-date').text(formattedStartDate + ' - ' + formattedEndDate);
 }
 // Function to update links based on the provided linkType


/* =========================================================
   13. FILTER PAGE LINKS / RESULT COUNTS
========================================================= */

const updateLinks = (linkType) => {
   const normalize = (val) => String(val || '').trim().toLowerCase();
   // Retrieve data from local storage
   const brand = getLocalStorage('brand');
   const model = getLocalStorage('model');
   const engine = getLocalStorage('engine');
   const engineArray = engine.split('--');
   const skuArray = [];

   // Filter car database based on selected criteria
   const filteredData = cachedCarDb.filter((item) =>
      item.make === brand &&
      item.model === model &&
      normalize(item.carName) === normalize(engineArray[0]) &&
      item['power(kW)'] === engineArray[1] &&
      item.cyl === engineArray[2] &&
      item.drivetype === engineArray[3]
   );

   // Check if any matching data is found
   if (filteredData.length === 0) {
      return;
   }

   // Extract SKU data for the given linkType from filtered data
   skuArray.push(
      ...filteredData
         .map((carData) => carData[linkType]) // Extracting the value first
         .filter(sku => sku !== '' && sku !== undefined && (typeof sku === 'string' || typeof sku === 'number')) // Filter out empty string, undefined and non-string/number values
         .map((sku) => typeof sku === 'string' ? sku.split(/ \| |\|/) : [sku.toString()]) // Splitting only if defined and a string
         .flat()
   );

   // Build SKU parameter and construct filtered collection URL
   const filteredCollection = buildSkuCollectionUrl((window.Shopify?.routes?.root || '/') + 'collections/all', skuArray);

   // Update the href attribute of the corresponding element with the filtered collection URL
   const elementId = `jsc-type-${linkType.toLowerCase()}`;
   // Category keys contain spaces, parentheses and slashes; they are not CSS selectors.
   const linkElement = document.getElementById(elementId);
   if (linkElement) {
      const link = $(linkElement);
      link.toggleClass('jsc-disabled-link', !filteredCollection);
      if (filteredCollection) link.attr('href', filteredCollection);
      else link.removeAttr('href');
   }
 };

 // Function to append filter page links for all specified link types
 const appendFilterPageLinks = () => {
   // Iterate through each link type and call updateLinks function
   carDbColumn.forEach((linkType) => updateLinks(linkType));
 };

// Function to update links based on the provided linkType
const updateLinkList = (linkType, linkUrl, linkClass) => {
   const normalize = (val) => String(val || '').trim().toLowerCase(); // Add this inside the function

   // Retrieve data from local storage
   const brand = getLocalStorage('brand');
   const model = getLocalStorage('model');
   const engine = getLocalStorage('engine');
   const engineArray = engine.split('--');
   const skuArray = [];

   // Filter car database based on selected criteria
   const filteredData = cachedCarDb.filter((item) =>
      item.make === brand &&
      item.model === model &&
      normalize(item.carName) === normalize(engineArray[0]) &&
      item['power(kW)'] === engineArray[1] &&
      item.cyl === engineArray[2] &&
      item.drivetype === engineArray[3]
   );

   if (filteredData.length === 0) {
      return;
   }

   // Extract SKU data for the given linkType from filtered data
   skuArray.push(
      ...filteredData
         .map((carData) => carData[linkType])
         .filter(sku => sku !== '' && sku !== undefined && (typeof sku === 'string' || typeof sku === 'number'))
         .map((sku) => typeof sku === 'string' ? sku.split(/ \| |\|/) : [sku.toString()])
         .flat()
   );

   const uniqueSkuArray = uniqueSkus(skuArray);

   const filteredCollection = buildSkuCollectionUrl(linkUrl, uniqueSkuArray);
   const skuLength = uniqueSkuArray.length;

   const $linkElements = $(`.${linkClass}`);
   if (skuLength) {
      $linkElements.removeClass('jsc-disabled-link').attr('href', filteredCollection);
   } else {
      $linkElements.addClass('jsc-disabled-link').removeAttr('href');
   }

   setTimeout(() => {
      const cardLinkLists = document.querySelectorAll(".card__link-list");
      cardLinkLists.forEach(cardLinkList => {
         cardLinkList.classList.add("active");
         const activeLinks = cardLinkList.querySelectorAll("li a:not(.jsc-disabled-link)");

         if (activeLinks.length > 0) {
            activeLinks.forEach(link => {
               link.closest("li").classList.add("active-jsc-link");
            });
         } else {
            cardLinkList.classList.add("no-available");
         }
      });
   }, 200);

   // Counts are resolved from storefront products, never from the number of requested SKUs.
   updateLinkCounts();
};

let categoryCountFrame = null;
function updateLinkCounts() {
  if (categoryCountFrame !== null) return;
  categoryCountFrame = requestAnimationFrame(() => {
    categoryCountFrame = null;
    window.dispatchEvent(new Event('autoclinic:category-links-updated'));
  });
}
function runLinkCountsFast() {
  // All links are updated synchronously; one notification is enough.
  updateLinkCounts();
}

function appendFilterPageLinkList() {
  const linkInfo = [];
  const $linkList = $('.jsc-link-list-car');

  $linkList.each(function () {
    const $this = $(this);

    linkInfo.push({
      type: toCamelCase($this.attr('data-part')),
      url: $this.attr('data-url'),
      class: `jsc-link-list-${$this.attr('data-part-handleize')}`
    });
  });

  linkInfo.forEach(({ type, url, class: className }) => updateLinkList(type, url, className));

  runLinkCountsFast();
}

document.addEventListener('DOMContentLoaded', function () {
  runLinkCountsFast();

  window.addEventListener('popstate', runLinkCountsFast);
  window.addEventListener('pushstate', runLinkCountsFast);
  window.addEventListener('replacestate', runLinkCountsFast);
});

// Polyfill for pushState and replaceState events
(function(history) {
    const pushState = history.pushState;
    const replaceState = history.replaceState;

    history.pushState = function(state, title, url) {
        const result = pushState.apply(history, arguments);
        window.dispatchEvent(new Event('pushstate'));
        return result;
    };

    history.replaceState = function(state, title, url) {
        const result = replaceState.apply(history, arguments);
        window.dispatchEvent(new Event('replacestate'));
        return result;
    };
})(window.history);

// Function to convert string into camelcase
const toCamelCase = (str) => {
   // Convert to camelCase
   // return str.replace(/\s(.)/g, (_, char) => char.toUpperCase())
   //           .replace(/\s/g, '')
   //           .replace(/^(.)/, (_, char) => char.toLowerCase());
   return str.replace(/-/g, ' ')
             .replace(/\s(.)/g, (_, char) => char.toUpperCase())
             .replace(/\s/g, '')
             .replace(/^(.)/, (_, char) => char.toLowerCase())
             .replace(/\(/g, ' (')
};

// Function to get all values of a URL parameter
const getParameterValues = (parameter) => {
   const urlParams = new URLSearchParams(window.location.search);
   return urlParams.getAll(parameter);
};

// Function to append Car filter into the CP filter form so doesn't remove the car filter when user interact with other filter 
appendURLFilterParamAsHiddenInputInCPFilter = () => {
   const skus = uniqueSkus(getParameterValues(SKU_FILTER_PARAM));
   $('.hidden-car-filter-value').each(function () {
      const container = $(this);
      container.empty();
      skus.forEach(sku => {
         $('<input>', { type: 'hidden', name: SKU_FILTER_PARAM, value: sku }).appendTo(container);
      });
   });
};

hideCPFilterOption = () =>{
   var axleFaArray = getLocalStorage('axle weight fa').split(',');
   var axleRaArray = getLocalStorage('axle weight ra').split(',');
   var contentOfDeliveryArray = getLocalStorage('content of delivery').split(',');
   var vehicleHasElectronicDamperArray = getLocalStorage('vehicle has electronic damper').split(',');
   var noteProductArray = getLocalStorage('note (product)').split(',');
   var diameterFaArray = getLocalStorage('diameter fa (mm)').split(',');
   var strutDiameterFrontAxleArray = getLocalStorage('strut diameter front axle (mm)').split(',');
   var rearAxleTypeArray = getLocalStorage('rear axle type').split(',');
   var noteCarArray = getLocalStorage('note (car assignment)').split(',');
   var frontAxleStrutsArray = getLocalStorage('front axle struts').split(',');

   var filterValueLi = $('.jsc-filter-check');

   filterValueLi.each(function(){
      var _this = $(this);
      var attrVal = _this.attr('data-filter-value');
      if (axleFaArray.includes(attrVal)) {
         _this.show();
      }
      if (axleRaArray.includes(attrVal)) {
         _this.show();
      }
      if (contentOfDeliveryArray.includes(attrVal)) {
         _this.show();
      }
      if (vehicleHasElectronicDamperArray.includes(attrVal)) {
         _this.show();
      }
      if (noteProductArray.includes(attrVal)) {
         _this.show();
      }
      if (diameterFaArray.includes(attrVal)) {
         _this.show();
      }
      if (strutDiameterFrontAxleArray.includes(attrVal)) {
         _this.show();
      }
      if (rearAxleTypeArray.includes(attrVal)) {
         _this.show();
      }
      if (noteCarArray.includes(attrVal)) {
         _this.show();
      }
      if (frontAxleStrutsArray.includes(attrVal)) {
         _this.show();
      }
   });
}

hideCpFilterWhenEmpty = () =>{
   var $grandparents = $('.jsc-cp-filter-parent');

   // Iterate through each grandparent
   $grandparents.each(function() {
      var $grandparent = $(this);
      var anyShown = true;

      // Find all grandchildren elements within the current grandparent
      var $grandchildren = $grandparent.find('.jsc-filter-check');

      // Iterate through each grandchild
      $grandchildren.each(function() {
          // Check if the current grandchild is hidden
          if ($(this).css('display') !== 'none') {
              anyShown = false;
              return false; // Exit the loop early since we found a hidden grandchild
          }
      });

      // If any grandchildren are hidden, adjust the height of the current grandparent

      if (anyShown) {
         //  $grandparent.hide();
      }
  });
}

//Load Selected car into line item properties Start
loadCarInfoToLIProperties = () =>{
   var brandName = getLocalStorage('brand');
   var modelValue = getLocalStorage('model');
   var engineValue = getLocalStorage('engine');

   if (brandName && modelValue && engineValue){
      var brandNameAndModel = `${brandName} ${modelValue}`;
      var engineFormatted = engineValue.replaceAll('--','-');

      $('#jsc-selected-brand-model, .jsc-selected-brand-model').val(brandNameAndModel);
      $('#jsc-selected-engine, .jsc-selected-engine').val(engineFormatted);
   }

   var brandNameAndModelValue = `${brandName} ${modelValue}`;
   brandNameAndModelValue = brandNameAndModelValue.split('(')[0].trim();
   $('.jsc-selected-model-title').text(brandNameAndModelValue);
}
//Load Selected car into line item properties End

/* =========================================================
   14. COMPATIBILITY / FITMENT CHECKING
========================================================= */

let compatibilityLoadPending = false;
const checkCompatibility = () => {
   const part = $('.compatible-part');
   if (!part.length) return;
   const brand = getLocalStorage('brand');
   const model = getLocalStorage('model');
   const engine = getLocalStorage('engine');
   if (!brand || !model || !engine) {
      updateCompatibilityUI(false);
      $('.jsc-negative-compatibility span').text('Please select your vehicle first to confirm item compatibility.');
      return;
   }
   if (!cachedCarDb) {
      $('.jsc-positive-compatibility, .jsc-negative-compatibility').hide();
      $('.checking-text').text('Loading vehicle compatibility…').show();
      if (!compatibilityLoadPending) {
         compatibilityLoadPending = true;
         fetchCarDb().then(() => { compatibilityLoadPending = false; checkCompatibility(); }, () => {
            compatibilityLoadPending = false;
            $('.checking-text').text('Unable to check compatibility. Please reload to try again.').show();
         });
      }
      return;
   }
   if (!String(part.attr('data-sku') || '').trim()) {
      $('.jsc-positive-compatibility, .jsc-negative-compatibility').hide();
      $('.checking-text').text('Choose a product option to check compatibility.').show();
      return;
   }
   updateCompatibilityUI(checkPartCompatibility(cachedCarDb, brand, model, engine.split('--'), part));
};

// Function to fetch car database JSON data
const fetchCarDatabase = (callback) => {
   loadAutoclinicData('carDb')
       .done(({ carDb }) => callback(carDb)) // Invoke callback function with car database
};

// Function to check compatibility of the part with the car database
let compatibilitySource = null;
let compatibilityVehicleIndex = new Map();
function compatibilityVehicleKey(brand, model, engine) {
   return JSON.stringify([brand, model, ...engine].map(value => String(value == null ? '' : value).trim().toLowerCase()));
}
const checkPartCompatibility = (carDb, brand, model, engineArray, compatiblePartElement) => {
   if (!Array.isArray(carDb) || engineArray.length !== 4) return false;
   if (compatibilitySource !== carDb) {
      compatibilitySource = carDb;
      compatibilityVehicleIndex = new Map();
      for (const car of carDb) {
         const key = compatibilityVehicleKey(car.make, car.model, [car.carName, car['power(kW)'], car.cyl, car.drivetype]);
         if (!compatibilityVehicleIndex.has(key)) compatibilityVehicleIndex.set(key, []);
         compatibilityVehicleIndex.get(key).push(car);
      }
   }
   const cars = compatibilityVehicleIndex.get(compatibilityVehicleKey(brand, model, engineArray)) || [];
   const sku = compatiblePartElement.attr('data-sku');
   return cars.some(car => carMatchesSku(car, sku));
};

// Function to update compatibility UI based on the result
let isPartCompatible = true; // track compatibility status globally

const updateCompatibilityUI = (isCompatiblePart) => {
    isPartCompatible = isCompatiblePart;

    const carSelected = $('.jsc-my-model-detail span').text().trim() !== '';

    if (isCompatiblePart) {
        $('.jsc-positive-compatibility').show();
        $('.jsc-negative-compatibility').hide();
    } else {
        $('.jsc-positive-compatibility').hide();
        $('.jsc-negative-compatibility').show();

        if (!carSelected) {
            $('.jsc-negative-compatibility span').text("Please select your vehicle first to confirm item compatibility.");
            $('.btn_cv').text("Select your vehicle here");
        } else {
            $('.jsc-negative-compatibility span').text("This part doesn't fit");
        }
    }

    $('.checking-text').hide();
};

// End of compatible part

$(document).on('click', '#livechat, a[href="#livechat"]', function(e) {
  e.preventDefault();

  // MY webshop
  if (window.location.pathname.startsWith('/en-my')) {
    window.location.href = '/en-my/pages/contact';
    return;
  }

  // Other markets
  if (typeof $respond !== 'undefined') {
    $respond.do("chat:open");
  }
});


/* =========================================================
   15. CART / ADD TO CART / EXHAUST ADD-ONS
========================================================= */

addOnsCheck = (exhaustDb) =>{
   setTimeout(() => {
      $('.add-ons-grids').flickity({
         cellAlign: 'left',
         contain: true,
         pageDots: false,
         groupCells: 2
       });
   }, 300);
}
// Working Select/Unselect
selectAddOns = (e) => {
    var _this = $(e);
    var isActive = _this.hasClass('active');

    // Remove "active" state from all siblings and hide their buttons
    _this.siblings().removeClass('active');
    _this.siblings().find('.jsc-selected-button').hide();

    if (isActive) {
        // If already active, unselect it and remove total text
        _this.removeClass('active');
        _this.find('.jsc-selected-button').hide();
        appendTotalAmountItem(_this, true); // Pass 'true' to remove total text
    } else {
        // Otherwise, select it
        _this.addClass('active');
        _this.find('.jsc-selected-button').show();
        appendTotalAmountItem(_this, false); // Add total text
    }
};
appendTotalAmountItem = (selectedItem, isRemoving = false) => {
   var bundle = selectedItem.parents('.bundle').find('.type-heading').text();
   var required = selectedItem.parents('.bundle').find('.required');
   var bundleNumber = parseInt(selectedItem.parents('.bundle').find('.type-heading').attr('data-count'));
   var title = selectedItem.find('.card__title').text();
   var price = selectedItem.find('.price').find('.price__default .price__current').text();
   var totalItemSelector = `#total-amount .bundle-${bundleNumber}`;

   if (isRemoving) {
      // Remove the total amount item when unselected
      $(totalItemSelector).remove();
   } else {
      // Add or update the total amount item
      if ($(totalItemSelector).length > 0) {
         $(totalItemSelector).html(`<span class="total-text">${title}</span><span class="line-price">${price}</span>`);
      } else {
         var addedItem = `<div class="total-amount-item bundle-${bundleNumber}"><span class="total-text">${title}</span><span class="line-price">${price}</span></div>`;
         $(addedItem).insertBefore('#total-amount .total-amount');
      }
   }

   // Remove required alert if applicable
   if ($(required).length > 0) {
      $(required).removeClass('required alert');
      $(required).find('.alert-message, .required-svg').addClass('d-none');
   }

   calculateTotalAmount();
};

calculateTotalAmount = () => {
   var total = 0;
   var linePrice = 0;

   // Select all total-text elements
   var totalTextElements = $('#total-amount .total-text');

   // Re-index items dynamically to remove gaps in numbering
   totalTextElements.each((index, element) => {
      var lineTitle = $(element).text().replace(/^\d+\.\s*/, ''); // Remove any existing numbering
      var newIndex = index + 1;
      $(element).text(newIndex + ". " + lineTitle);
   });

   $('#total-amount .line-price').each((index, element) => {
      linePrice = $(element).text().trim().replace(/[^\d.]/g, '');
      linePrice = parseFloat(linePrice) || 0; // Ensure valid number
      total += linePrice;
   });

   var formattedAmount = Number(total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
   var formattedShopifyMoney = theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, formattedAmount); 
   $('#total-amount .total-amount-price').text(formattedShopifyMoney);
}

addExhaust = (e, vid) =>{
   var _this = $(e);
   var _activeSelection = $('.jsc-add-ons.active');
   var required = $('.bundle .required');
   var _html = '';
   var _temp = 1;
   var _bindId = vid;
   var itemsArray = [];

   const compatiblePartElement = $('.compatible-part');
   // Get brand, model, and engine details from local storage
   const brand = getLocalStorage('brand');
   const model = getLocalStorage('model');
   const engine = getLocalStorage('engine');
   const engineArray = engine.split('--');

   // Check compatibility of the part with the selected criteria
   const isCompatiblePart = checkPartCompatibility(cachedCarDb, brand, model, engineArray, compatiblePartElement);

   if ($(required).length > 0) {
      $(required).each((index, element) => {
         $(element).addClass('alert');
         $(element).find('.required-svg').removeClass('d-none');
         $(element).find('.alert-message').removeClass('d-none');
      });
      var parent_id = $(required[0]).parent().attr('id');
      if (isCompatiblePart) {
         var errorHtml = `Click <a href="#${parent_id}">here</a> to choose the required bundle.`;
      } else {
         var errorHtml = `The parts are unavailable for your selected vehicle. Please <span class="cursor d-inline-block underline fontWeight-9" onclick="changeVehicleTrigger(this,'page')">select</span> a different vehicle to proceed. If you need assistance, please contact us.`;
      }
      $('.exhaust-error.js-form-error').html(errorHtml);
      $('.exhaust-error.js-form-error').removeAttr('hidden');
   } else {
      $('.exhaust-error.js-form-error').attr('hidden');

      loader.show();

      _activeSelection.each(function(){
         var _active = $(this);
         var _title = _active.attr('data-title').trim();
         var _vid = _active.attr('data-vid');
         var _sku = _active.attr('data-sku');
         var _price = _active.find('.price__default .price__current').text();

         if (_title != 'No Selection') {
            // Determine property name based on keywords in the title
            var propertyKey = "Add_on"; // Default in case no match is found

            if (_title.toLowerCase().includes("connection tube")) {
               propertyKey = "Tube";
            } else if (_title.toLowerCase().includes("intermediate pipe")) {
               propertyKey = "Pipe";
            } else if (_title.toLowerCase().includes("tail pipe")) {
               propertyKey = "Tail Pipe";
            } else if (_title.toLowerCase().includes("tailpipe")) {
               propertyKey = "Tail Pipe";
            } else if (_title.toLowerCase().includes("tailpipes")) {
               propertyKey = "Tail Pipe";
            }

            var _objs = {
               id: _vid,
               quantity: 1,
               properties: {
                  "_bindId": "blank",
                  [propertyKey]: `${_title} x 1 - ${_price}` // Use dynamically assigned label
               }
            };
            itemsArray.push(_objs);
         }

         _html += `<input type="text" name="properties[${propertyKey}]" value="${_title} x 1 - ${_price}" style="display: none;">`;
         _bindId += `-${_vid}`;

         _temp++;
      });

      $.each(itemsArray, function(index, item) {
         item.properties['_bindId'] = _bindId;
      });

      CartJS.addItems(itemsArray);

      _html += `<input type="text" name="properties[_bindId]" value="${_bindId}" style="display: none;"><input type="text" name="properties[_main_product]" value="true" style="display: none;">`;

      $(_html).insertBefore(_this);

      $(document).on('cart.requestComplete', function(event, cart) {
         _this.siblings('.jsc-add-to-cart').click();
         setTimeout(() => {
            loader.hide();
         }, 3000);
      });
   }
}

removeExhaust = (e) =>{
   loader.show();
   var _this = $(e);
   var obj = {};

   // Get the bind ID
   var bindId = _this.attr('data-bindid');
   var selector = $(`.jsc-bindid-${bindId}`);

   selector.each(function(){
      obj[$(this).attr('data-key')] = 0;
   });

   CartJS.updateItemQuantitiesById(obj);

   $(document).on('cart.requestComplete', function(event, cart) {
      // loader.hide();
      setTimeout(() => {
         location.reload();
      }, 3000);
   });
}



/* =========================================================
   16. SWIPERS / SLIDERS
========================================================= */

updatePaginationStyles = (swiper) => {
   const paginationBullets = $(swiper.el).find('.swiper-pagination-bullet');
   const totalSlides = paginationBullets.length;
   const bulletWidth = 100 / totalSlides - 5;

   paginationBullets.each(function() {
      $(this).css('width', `${bulletWidth}%`);
   });
}

updateSlideHeights = (swiper) => {
   const $slides = $(swiper.el).find('.swiper-slide');
   $slides.css('height', 'auto');
   var maxHeight = 0;
   $slides.each(function() {
      var $slide = $(this);
      var slideHeight = $slide.outerHeight();
      if (slideHeight > maxHeight) {
         maxHeight = slideHeight;
      }
   });

  $slides.css('height', maxHeight + 'px');
}

initMultiColumnSwiper = () => {
    $('.swiper.multiColumnSwiper').each(function(index, element) {
        var _this = $(element);
        var columns = Math.max(1, Number(element.dataset.columns) || 3);
        var autoplay = _this.data('autoplay');
        var autoplaySpeed = Number(_this.data('autoplay-speed'));

        if (element.multiColumnCleanup) element.multiColumnCleanup();
        if (element.swiper) element.swiper.destroy(true, true);

        var wrapper = element.querySelector('.swiper-wrapper');
        if (!wrapper) return;

        var slides = Array.from(wrapper.children).filter(function(slide) {
            return slide.classList.contains('swiper-slide') &&
                !slide.classList.contains('swiper-slide-duplicate');
        });

        element.style.setProperty('--mc-columns', columns);
        element.style.setProperty('--mc-tablet-columns', Math.min(columns, 2));
        element.style.setProperty('--mc-card-count', Math.max(1, Math.min(slides.length, columns)));
        element.style.setProperty('--mc-tablet-count', Math.max(1, Math.min(slides.length, columns, 2)));

        var mobileQuery = window.matchMedia('(max-width: 767px)');

        function updateLayout() {
            var useCarousel = mobileQuery.matches ? slides.length > 2 : slides.length > 4;
            if (!useCarousel) {
                if (element.swiper) element.swiper.destroy(true, true);
                element.classList.add('is-static-grid');
                return;
            }
            if (element.swiper) return;
        element.classList.remove('is-static-grid');

        var options = {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 5,
            watchOverflow: true,
            centerInsufficientSlides: true,
            initialSlide: 0,
            on: {
                init: function() {
                    updatePaginationStyles(this);
                    updateSlideHeights(this);
                },
                resize: function() {
                    updatePaginationStyles(this);
                    updateSlideHeights(this);
                }
            },
            pagination: {
                el: element.querySelector('.swiper-pagination'),
                clickable: true
            },
            breakpoints: {
                480: { slidesPerView: Math.min(columns, 2), spaceBetween: 15 },
                768: { slidesPerView: Math.min(columns, 2), spaceBetween: 20 },
                1024: { slidesPerView: columns, spaceBetween: 20 }
            }
        };

        if ((autoplay === true || autoplay === 'true') && autoplaySpeed > 0) {
            options.autoplay = {
                delay: autoplaySpeed,
                disableOnInteraction: false
            };
        }

        new Swiper(element, options);
        }

        if (mobileQuery.addEventListener) {
            mobileQuery.addEventListener('change', updateLayout);
        } else {
            mobileQuery.addListener(updateLayout);
        }

        element.multiColumnCleanup = function() {
            if (mobileQuery.removeEventListener) {
                mobileQuery.removeEventListener('change', updateLayout);
            } else {
                mobileQuery.removeListener(updateLayout);
            }
            if (element.swiper) element.swiper.destroy(true, true);
        };

        updateLayout();
    });
};




const filterPage = document.querySelector('filter-page');

if (filterPage && filterPage.offsetParent !== null) {
  const link = document.querySelector('a[href*="ecu-piggyback-2-euro-cars"].jsc-link-list-ecu-piggyback-2-euro-cars');
  if (link) {
    link.textContent = 'ECU PIGGYBACK (Euro Cars)';
  }
}

//document.querySelector('a[href*="ecu-piggyback-2-euro-cars"].jsc-link-list-ecu-piggyback-2-euro-cars').textContent = 'ECU PIGGYBACK (Euro Cars)'; 
document.addEventListener("DOMContentLoaded", function() {
    var bannerElement = document.querySelector('.banner-model-car');
    if (bannerElement) {
        bannerElement.classList.remove('hidden');
    }
});

// Popup controls must never also trigger the old banner-scroll handler.
$('.slideshow .btn--secondary').on('click', function (event) {
  if (this.matches('[onclick*="openCarPopup"], [onclick*="changeVehicleTrigger"], .open-car-selector, .btn_cv')) return;
  const href = this.getAttribute('href');
  if (!href || href === '#' || !href.startsWith('#')) return;
  let target;
  try { target = document.getElementById(decodeURIComponent(href.slice(1))); } catch (_) { return; }
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth' });
});



/* =========================================================
   17. GENERAL CLICK / POPUP HANDLERS
========================================================= */

function buildSelectedVehicleCollectionUrl() {
  const url = new URL(window.location.href);
  const isCollectionPage = /^\/(?:en-(?:sg|my)\/)?collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname)
    && !/\/products(?:\/|$)/.test(url.pathname);
  const vehicle = getCompletePopupVehicle();
  if (!isCollectionPage || !vehicle) return null;

  const engineParts = vehicle.engine.split('--');
  // Include every matching database row, since one vehicle may span several rows.
  const matchingCars = cachedCarDb.filter(car =>
    normalize(car.make) === normalize(vehicle.brand) &&
    normalize(car.model) === normalize(vehicle.model) &&
    normalize(car.carName) === normalize(engineParts[0]) &&
    normalize(car['power(kW)']) === normalize(engineParts[1]) &&
    normalize(car.cyl) === normalize(engineParts[2]) &&
    normalize(car.drivetype) === normalize(engineParts[3])
  );
  const skus = uniqueSkus(matchingCars.flatMap(car =>
    carDbColumn.flatMap(column => splitSkuValues(car[column]))
  ));

  // The collection renderer restricts these vehicle SKUs to the current collection.
  // Replace the previous car's filters and reset pagination/vendor selection.
  ['filter.p.m.json.handle', 'filter.p.m.custom.skus', 'view', 'sku',
    'page', 'sku_page', 'sku_vendor'].forEach(key => url.searchParams.delete(key));
  skus.forEach(sku => url.searchParams.append(SKU_FILTER_PARAM, sku));
  // Keep SKU mode enabled for an empty result instead of showing unfiltered products.
  if (!skus.length) url.searchParams.set(SKU_FILTER_PARAM, '');

  const selectedCar = matchingCars.find(car => car.carId);
  if (selectedCar) url.searchParams.set('carId', selectedCar.carId);
  else url.searchParams.delete('carId');

  return url.pathname + url.search + url.hash;
}

let collectionSelectionRefreshId = 0;

function refreshCollectionAfterVehicleSelection() {
  const destination = buildSelectedVehicleCollectionUrl();
  if (!destination) return;
  const refreshId = ++collectionSelectionRefreshId;

  // Finish the selection event and fade before loading the filtered collection.
  requestAnimationFrame(() => {
    if (refreshId !== collectionSelectionRefreshId) return;
    closeCarPopup(true);
    getCarModalElements().promise().done(() => {
      if (refreshId !== collectionSelectionRefreshId) return;
      window.location.assign(destination);
    });
  });
}

// #myPopup is also used for the inline homepage banner. Prefer the actual modal.
function getCarModalElements() {
  const modal = $('jsc-popup');
  return modal.length ? modal : $('#myPopup');
}

function closeCarPopup(smooth = false) {
  if (!document.body.classList.contains('model-open')) return;
  const popups = getCarModalElements();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Finish any previous animation before starting another close.
  popups.stop(true, true);

  if (smooth && !reduceMotion && popups.is(':visible')) {
    // Keep scrolling locked until the collection popup has finished fading out.
    popups.filter(':visible').fadeOut(220).promise().done(() => {
      $('body').removeClass('model-open');
    });
    return;
  }

  popups.hide();
  $('body').removeClass('model-open');
}

document.addEventListener('click', function (event) {
  const isOpen = document.body.classList.contains('model-open') && getCarModalElements().is(':visible');
  if (!isOpen) return;

  const clickedInsideContent = event.target.closest(
    'jsc-popup-content, jsc-popup-body, jsc-popup-select, jsc-popup-my-model, .jsc-popup-content, .jsc-popup-body, #myPopup > *'
  );

  const clickedOpenTrigger = event.target.closest(
    '.jsc-header-car, .jsc-nav-car, .jsc-mobile-view-car, .jsc-header-car-mobile, #home-header-car, #menu_banner, .btn_cv, .open-car-selector, [onclick*="openCarPopup"], [onclick*="changeVehicleTrigger"]'
  );

  if (clickedInsideContent || clickedOpenTrigger) return;

  closeCarPopup();
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') closeCarPopup();
});

document.addEventListener("click", function (e) {
  const btn = e.target.closest('.text-overlay__block .btn--primary');
  if (!btn) return;

  // Skip live chat button
  if (btn.id === "livechat") return;

  const href = btn.getAttribute('href');

  // ⚠️ If there is a legit URL (non-empty, not just "#"), let it behave normally
  if (href && href !== "#") {
    return;
  }

  // Only here if href is "", null, or "#"
  e.preventDefault();
  e.stopPropagation();

  // OPEN CAR SELECTOR POPUP
  if (typeof openCarPopup === "function") {
    openCarPopup(e);
  } else if (typeof openCarFilters === "function") {
    openCarFilters();
  }
});

// Open car selector when a link/button has href="#"
// Open car selector only for intended links with href="#"
document.addEventListener("click", function (e) {
  const el = e.target.closest('a[href], .btn[href]');
  if (!el) return;

  // Ignore Shopify dynamic checkout controls
  if (
    el.closest('.shopify-payment-button') ||
    el.closest('shopify-buy-it-now-button') ||
    el.closest('shopify-google-pay-button') ||
    el.closest('more-payment-options-link') ||
    el.classList.contains('shopify-payment-button__more-options')
  ) {
    return;
  }

  // Ignore live chat
  if (
    el.id === "livechat" ||
    el.getAttribute("href") === "#livechat"
  ) {
    return;
  }

  // Ignore header and mega-navigation links
  if (
    el.closest('.main-nav') ||
    el.closest('.mega-nav') ||
    el.classList.contains('main-nav__item-content') ||
    el.classList.contains('main-nav__item--primary')
  ) {
    return;
  }

  const href = (el.getAttribute("href") || "").trim();

  if (href !== "#") return;

  e.preventDefault();
  e.stopPropagation();

  if (typeof openCarPopup === "function") {
    openCarPopup(e);
    return;
  }

  const popup = document.getElementById("myPopup");

  if (popup) {
    popup.style.display = "block";
    document.body.classList.add("model-open");
  }
}, true);

// === Fetch Brand and Exhaust DBs ===
const fetchBrandDb = () => {
  return loadAutoclinicData('filter')
    .then(json => {
      brandDb = json.filter;
      console.log("Brand DB sample:", brandDb?.[0]);
      return brandDb;
    });
};

(function () {
  const threshold = 500;
  let initialized = false;

  function attach(el) {
    if (initialized) return;
    initialized = true;

    function toggle() {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      el.classList.toggle("is-hidden", y < threshold);
    }

    // Let Respond.io finish mounting
    setTimeout(() => {
      el.classList.add("is-hidden");
      toggle();
    }, 400);

    window.addEventListener("scroll", toggle, { passive: true });
  }

  function init() {
    // Only run on homepage
    if (!document.body.classList.contains("home")) return false;

    const el = document.getElementById("dbee1");
    if (!el) return false;

    attach(el);
    return true;
  }

  // Try immediately
  if (init()) return;

  // Watch for Respond.io injection
  const observer = new MutationObserver(() => {
    if (init()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Safety fallback
  setTimeout(() => {
    observer.disconnect();
    init();
  }, 8000);
})();




/* =========================================================
   18. ARTICLE HASH SCROLLING
========================================================= */

(function () {
  /* ============================
     RUN ONLY ON ARTICLE PAGES
  ============================ */
  const articleRoot = document.querySelector('.page-builder-article');

  // Exit if not article page or element is hidden
  if (
    !articleRoot ||
    articleRoot.offsetParent === null || // not visible
    getComputedStyle(articleRoot).display === 'none'
  ) {
    return;
  }

  /* ============================
     CONFIG
  ============================ */
  const EXTRA_GAP = 20;

  const HEADER_SELECTORS = [
    "#shopify-section-header",
    ".header-wrapper",
    "sticky-header",
    "header",
    ".site-header",
    ".section-header"
  ];

  /* ============================
     HELPERS
  ============================ */
  function getHeaderOffset() {
    for (const sel of HEADER_SELECTORS) {
      const el = document.querySelector(sel);
      if (!el) continue;

      const styles = window.getComputedStyle(el);
      const isSticky =
        styles.position === "sticky" ||
        styles.position === "fixed" ||
        el.classList.contains("sticky") ||
        el.classList.contains("is-sticky");

      if (isSticky) {
        return Math.ceil(el.getBoundingClientRect().height) + EXTRA_GAP;
      }
    }
    return 110;
  }

  function findTarget(hash) {
    if (!hash) return null;

    const raw = decodeURIComponent(hash.replace("#", "")).trim();
    if (!raw) return null;

    return (
      document.getElementById(raw) ||
      document.querySelector(`[name="${CSS.escape(raw)}"]`)
    );
  }

  function scrollToTarget(hash, behavior) {
    const el = findTarget(hash);
    if (!el) return false;

    const offset = getHeaderOffset();
    const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: Math.max(0, y), behavior });

    if (typeof el.focus === "function") {
      el.setAttribute("tabindex", "-1");
      el.focus({ preventScroll: true });
    }

    return true;
  }

  function runHashScroll({ behavior = "smooth" } = {}) {
    const hash = window.location.hash;
    if (!hash) return;

    try {
      if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    } catch (e) {}

    const start = Date.now();
    const maxMs = 3000;
    const tickMs = 60;

    const timer = setInterval(() => {
      const ok = scrollToTarget(hash, behavior);
      if (ok || Date.now() - start > maxMs) clearInterval(timer);
    }, tickMs);
  }

  /* ============================
     PREVENT INITIAL HASH JUMP
  ============================ */
  (function neutralizeInitialJump() {
    const hash = window.location.hash;
    if (!hash) return;

    try {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    } catch (e) {}

    window.scrollTo(0, 0);

    setTimeout(() => {
      try {
        history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search + hash
        );
      } catch (e) {
        window.location.hash = hash;
      }
      runHashScroll({ behavior: "smooth" });
    }, 50);
  })();

  /* ============================
     EVENTS
  ============================ */
  document.addEventListener("DOMContentLoaded", () =>
    setTimeout(() => runHashScroll({ behavior: "smooth" }), 50)
  );

  window.addEventListener("load", () =>
    setTimeout(() => runHashScroll({ behavior: "smooth" }), 50)
  );

  window.addEventListener("hashchange", () => {
    setTimeout(() => runHashScroll({ behavior: "smooth" }), 0);
  });
})();


function repositionMobileSelectedVehicle() {
  const mobileBreakpoint = window.matchMedia('(max-width: 767px)');
  const mainMenu = document.querySelector('nav[aria-label="Primary"] .main-nav');
  const selectedVehicle = mainMenu?.querySelector(
    '.main-menu--left-mob__car-finder'
  );

  if (!mainMenu || !selectedVehicle) return;

  // Remember its original desktop position.
  if (!selectedVehicle._originalNextSibling) {
    selectedVehicle._originalNextSibling = selectedVehicle.nextSibling;
  }

  if (mobileBreakpoint.matches) {
    // Move Selected Vehicle above the first menu item, which is Shop.
    if (mainMenu.firstElementChild !== selectedVehicle) {
      mainMenu.insertBefore(selectedVehicle, mainMenu.firstElementChild);
    }
  } else {
    // Restore its original position on desktop.
    const originalNextSibling = selectedVehicle._originalNextSibling;

    if (
      originalNextSibling &&
      originalNextSibling.parentNode === mainMenu
    ) {
      mainMenu.insertBefore(selectedVehicle, originalNextSibling);
    } else {
      mainMenu.appendChild(selectedVehicle);
    }
  }
}

document.addEventListener('DOMContentLoaded', repositionMobileSelectedVehicle);

window.addEventListener('resize', repositionMobileSelectedVehicle);


// Independently initialize fitment and refresh it when variant SKU markup changes.
$(function () {
   const safeCheck = () => {
      try { checkCompatibility(); }
      catch (error) {
         console.error('Compatibility UI error:', error);
         $('.checking-text').text('Compatibility could not be checked. Please reload to try again.').show();
      }
   };
   // Fitment is a separate consumer. Its failure cannot reject the shared data request.
   loadAutoclinicData('carDb').done(function (data) {
      cachedCarDb = data.carDb;
      window.setTimeout(safeCheck, 0);
   });
   const part = document.querySelector('.compatible-part');
   if (part) {
      const observer = new MutationObserver(safeCheck);
      observer.observe(part, { attributes: true, attributeFilter: ['data-sku'] });
   }
});

// Start both requests as soon as this asset executes, rather than waiting for
// document-ready handlers. Shared promises prevent duplicate network requests.
loadAutoclinicData('filter');
loadAutoclinicData('carDb');


/* Keep the popup Product Overview link in the current storefront market. */
(function () {
  const selector = 'a.product-overview-for-my-car';

  function updateLink(link) {
    const prefix = autoclinicMarketPrefix();
    const url = new URL(link.getAttribute('href') || '/pages/my-car-model', window.location.origin);
    url.pathname = prefix + '/pages/my-car-model';
    const href = url.pathname + url.search + url.hash;
    if (link.getAttribute('href') !== href) link.setAttribute('href', href);
  }

  function updateLinks() {
    document.querySelectorAll(selector).forEach(updateLink);
  }

  $(function () {
    updateLinks();
    // The theme can insert or rebuild the popup after the initial page load.
    const observer = new MutationObserver(function (records) {
      if (records.some(record =>
        record.type === 'attributes'
          ? record.target.matches(selector)
          : [...record.addedNodes].some(node => node.nodeType === 1 &&
              (node.matches(selector) || node.querySelector(selector)))
      )) updateLinks();
    });
    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['href']
    });
  });

})();
